import { MetaResponse } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { AssetSelectedTypeMap, ProductItem, ProductStatus } from '../types';

export const productStatusState = atom<ProductStatus>({
  key: 'productStatusState',
  default: { label: 'Selecione o produto', status: 'locked' },
});

export const productItemState = atom({
  key: 'productItemState',
  default: { current: {}, previous: {} } as ProductItem,
});

export const emptyOffersLoadedState = atom({
  key: 'emptyOffersLoadedState',
  default: { data: [] as any[], meta: {} as MetaResponse, loaded: true },
});

export const productsHeightState = atom({
  key: 'productsHeightState',
  default: { heights: {} as Record<keyof AssetSelectedTypeMap, number> },
});

export * from './fixedIncome';
export * from './funds';
export * from './equity';
export * from './directTreasury';
export * from './structuredOperations';
export * from './publicOffer';
export * from './clubs';
export * from './privatePension';
